import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=a6b24834&scoped=true"
import script from "./Google.vue?vue&type=script&lang=js"
export * from "./Google.vue?vue&type=script&lang=js"
import style0 from "./Google.vue?vue&type=style&index=0&id=a6b24834&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b24834",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6b24834')) {
      api.createRecord('a6b24834', component.options)
    } else {
      api.reload('a6b24834', component.options)
    }
    module.hot.accept("./Google.vue?vue&type=template&id=a6b24834&scoped=true", function () {
      api.rerender('a6b24834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page2/social/Google.vue"
export default component.exports